import Vue from "vue";
import VueRouter from "vue-router";

import AuthHelpers from "../utils/auth-helpers";

import ngoProfileRoutes from "../modules/ngo/ngo-profile/router";
import ministryRoutes from "../modules/ministry/router";
import tempNgoRoutes from "../modules/temp-ngo/router";
import ngoProgramsRoutes from "../modules/ngo/programs-and-activities/router";
import ngoHomeRoutes from "../modules/home/router";
import ngoPlanRoutes from "../modules/ngo/annual-plan/router";
import AuthRoutes from "../modules/auth/router";
import propertiesRoutes from "../modules/ngo/properties/router";
import administrative from "../modules/ngo/administrative-status/router";
import ManageInterfaceNgo from "../modules/ngo/guest-pages-management/router";
import ministryRelationRoutes from "../modules/ngo/ministry-relation/router";
import MiscRoutes from "./routes/apps";
import techSupport from "../modules/ngo/technical-support/router";
import userProfile from "../modules/user-profile/router";
import userNotifications from "../modules/notifications/router";
import financialRoutes from "../modules/ngo/financial/router";
import unCoopRoutes from "../modules/ngo/un-coop/router";
import tashbeekRoutes from "../modules/ngo/tashbeek/router";
import transactionsRoutes from "../modules/ngo/transactions/router";
import docsRoutes from "../modules/docs/router";
import globalsRoutes from "../modules/globals/router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", redirect: { name: "home" } },
    ...ngoHomeRoutes,
    ...AuthRoutes,
    ...ngoProgramsRoutes,
    ...ngoProfileRoutes,
    ...ngoPlanRoutes,
    ...tempNgoRoutes,
    ...administrative,
    ...ManageInterfaceNgo,
    ...ministryRoutes,
    ...MiscRoutes,
    ...propertiesRoutes,
    ...techSupport,
    ...userProfile,
    ...userNotifications,
    ...ministryRelationRoutes,
    ...financialRoutes,
    ...unCoopRoutes,
    ...tashbeekRoutes,
    ...docsRoutes,
    ...globalsRoutes,
    ...transactionsRoutes,

    {
      path: "/messaging/:folder",
      name: "messaging",
      props: { folder: 'received' } ,
      component: () =>
        /* webpackChunkName: "messaging-module" */ import(
          "@/modules/messaging/pages/Email.vue"
        ),
      meta: {
        requireAuth: true,
        contentRenderer: "sidebar-left",
        contentClass: "email-application",
        navActiveLink: "apps-email",
      },
      beforeEnter(to, _, next) {
        if (!to.params.folder) next({ ...to, params: { folder: "received" } });
        else if (["sent", "received"].includes(to.params.folder)) next();
        else next({ name: "error-404" });
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: () => import("@/modules/ngo/chat/pages/Chat.vue"),
      meta: {
        requireAuth: true,
        contentRenderer: "sidebar-left",
        contentClass: "chat-application",
      },
    },
    {
      path: "/payment-summary",
      name: "payment-summary",
      component: () => import("@/views/payment-summary.vue"),
      meta: {
        layout: "full",
        whiteListed: true,
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/Error404.vue"),
      meta: {
        layout: "full",
        whiteListed: true,
      },
    },
    {
      path: "/unauthorized-401",
      name: "unauthorized-401",
      component: () => import("@/views/Unauthorized401.vue"),
      meta: {
        layout: "full",
        whiteListed: true,
      },
    },
    {
      path: "/file-view",
      name: "file-view",
      component: () => import("@/views/ViewFile.vue"),
      meta: {
        layout: "full",
        whiteListed: true,
      },
    },
    {
      path: "/ngo-data",
      name: "ngo-data",
      component: () => import("@/views/NgoQrData.vue"),
      beforeEnter(to, _, next) {
        if (!to.query.QR) return next({ name: "error-404" });
        return next();
      },
      props: true,
      meta: {
        layout: "full",
        whiteListed: true,
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.whiteListed) {
    return next();
  }
  const isLoggedIn = AuthHelpers.isUserLoggedIn();
  const isUserTemp = AuthHelpers.isUserTemp();
  const isUserMinistry = AuthHelpers.isUserMinistry();
  if (isLoggedIn && !isUserTemp && to.name === "messaging") return next();

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    if (isUserTemp) next({ name: "temp-ngo" });
    else if (isUserMinistry) next({ name: "ministry-dashboard" });
    else next({ name: "ngo-profile" });
  } else if (!isLoggedIn && !to.meta.whiteListed) {
    if (to.name === "auth-login" || to.name === "ministry-login") return next();
    else {
      return next({ name: "auth-login" });
    }
  } else {
    if (to.meta.slug && !AuthHelpers.canNavigate(to.meta.slug))
      return next({ name: "unauthorized-401" });
    if (!isUserTemp && !isUserMinistry && (to.meta.temp || to.meta.ministry))
      return next({ name: "ngo-profile" });
    if (isUserTemp && !to.meta.temp) return next({ name: "temp-ngo" });
    if (isUserMinistry && !to.meta.ministry) {
      if (localStorage.getItem("ni") && localStorage.getItem("passToken"))
        return next();
      else return next({ name: "ministry-dashboard" });
    } else return next();
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
